import React, { useState } from 'react';
import BatteryConfig from '../components/BatteryConfig';
import { Typography } from '@mui/material';
import { StyledButton, StyledTypography } from '../styles/styles';
import { useBatteryConfig } from "../context/BatteryConfigContext";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import SettingsIcon from '@mui/icons-material/Settings';
import { useNavigate } from "react-router-dom";


const DigitalTwin = () => {
    const { selectedConfig, setSelectedConfig } = useBatteryConfig();
    console.log(selectedConfig);
    const [isConfig, setIsConfig] = useState(false);
    const toggleConfig = () => {
        setIsConfig(!isConfig);
    };
    const navigate = useNavigate();

    const handleNavigateToSubmit = () => {
        navigate("/batteryscope/submit");
    };

    const handleNavigateToValidateDigitalTwin = () => {
        navigate("/batteryscope/validate-digital-twin");
    };

    return (
        <div className="submit-battery-data mt-11">
            {selectedConfig ? (
                <>
                    <StyledTypography variant="h6">
                        Digital Twin Configuration
                    </StyledTypography>
                    <StyledTypography variant="body1">
                        The digital twin configuration of the battery pack is as follows:
                    </StyledTypography>
                    <div className="flex flex-row justify-between gap-4 mt-5">
                        {/* <StyledButton variant="contained" color="secondary" onClick={toggleConfig} className='gap-1'>
                            {isConfig ? "Procure Battery" : "Configure Battery"}  <SettingsIcon />
                        </StyledButton> */}
                        <StyledButton variant="contained" color="secondary" onClick={handleNavigateToValidateDigitalTwin} className='gap-1'>
                            Validate Digital Twin <CheckCircleIcon />
                        </StyledButton>
                    </div>
                    <BatteryConfig
                        voltage={selectedConfig.voltage}
                        capacity={selectedConfig.capacity}
                        cellType={selectedConfig.cellType}
                        cellCondition={"Recycled cell"}
                        ageYears={selectedConfig.ageYears}
                        ageMonths={selectedConfig.ageMonths}
                        chemistry={selectedConfig.chemistry}
                        format={selectedConfig.format}
                        makeModel={selectedConfig.makeModel}
                        isConfig={isConfig}
                        setIsConfig={setIsConfig}
                        setSelectedConfig={setSelectedConfig}
                        selectedConfig={selectedConfig}
                    />
                </>
            ) : (
                <>
                    <StyledTypography variant="h6" sx={{ color: "#e8442d" }}>
                        No Battery Data Selected
                    </StyledTypography>
                    <Typography variant="body1" gutterBottom className="mt-2 mb-4">
                        To visualize battery data, please submit your battery configuration first.
                    </Typography>
                    <StyledButton variant="contained" color="primary" onClick={handleNavigateToSubmit}>
                        Go to Submit Page
                    </StyledButton>
                </>
            )}
        </div>
    );
}

export default DigitalTwin;
